import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

const chipSx = ({ active, disabled, fullWidth, theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0.5,
  height: 32,
  px: 1.25,
  borderRadius: "8px",
  border: "1px solid",
  borderColor: active ? "transparent" : "#E4E4E7",
  background: active ? theme.palette.button.primary.main : "#fff",
  color: active
    ? theme.palette.button.primary.contrastText
    : "text.primary",
  fontSize: "13px",
  fontWeight: 500,
  fontFamily: "inherit",
  appearance: "none",
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.5 : 1,
  userSelect: "none",
  flex: fullWidth ? "1 1 0" : "0 0 auto",
  minWidth: 0,
  whiteSpace: "nowrap",
  ...(active && !disabled
    ? {
        "&:hover": {
          background: theme.palette.button.primary.hover.main,
          color: theme.palette.button.primary.hover.contrastText,
        },
      }
    : {}),
});

const ProduceToggleChips = ({
  options = [],
  selectedValues = [],
  onToggle,
  disabled = false,
  multiple = true,
  fullWidth = false,
}) => {
  const theme = useTheme();
  const selectedSet = new Set(selectedValues);

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
      {options.map((option) => {
        const selected = selectedSet.has(option.value);
        return (
          <Box
            key={option.value}
            component="button"
            type="button"
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              if (!multiple && selected) return;
              onToggle(option.value);
            }}
            sx={chipSx({
              active: selected,
              disabled,
              fullWidth,
              theme,
            })}
          >
            {option.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default ProduceToggleChips;
